import { createAction } from '../../../core/helpers'

import { FETCH_DIET_CATEGORY } from '../action-types'

export const cleanupFetchDietCategory = createAction(
  FETCH_DIET_CATEGORY.CLEANUP,
)
